import { render, staticRenderFns } from "./account_view.vue?vue&type=template&id=0b90ae5e&scoped=true&"
import script from "./account_view.vue?vue&type=script&lang=js&"
export * from "./account_view.vue?vue&type=script&lang=js&"
import style0 from "./account_view.vue?vue&type=style&index=0&id=0b90ae5e&prod&scoped=true&lang=scss&"
import style1 from "./account_view.vue?vue&type=style&index=1&id=0b90ae5e&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b90ae5e",
  null
  
)

export default component.exports